import * as angular from 'angular';
import {
    mobileApplicationSettingsFromDto,
    mobileApplicationSettingsToDto
} from './mobile-app-support.functions';

export class Controller {

    /** @ngInject */
    constructor($state, Alert, ApplicationsResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
    }

    $onInit() {
        this.$settings = mobileApplicationSettingsFromDto(this.application.mobileApplicationSettings);
        this.settings = {...this.$settings};
    }

    cancel() {
        this.$onInit();
    }

    notModified() {
        return angular.equals(this.$settings, this.settings);
    }

    onChange($value, $invalid) {
        this.settings = $value;
        this.$invalid = $invalid;
    }

    save() {
        this.isSaving = true;
        const mobileApplicationSettings = mobileApplicationSettingsToDto(this.settings);
        const application = {...this.application, mobileApplicationSettings};
        this.ApplicationsResource
            .updateApplicationConfiguration(this.companyId, this.application.id, application)
            .then(() => {
                this.Alert('success', 'company.manage-application.mobile-app-support.saved');
                Object.assign(this.application, application);
                this.$settings = {...this.settings};
                this.$state.reload('company.manage-application');
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/mobile-app-support/mobile-app-support.controller.js